<template lang="pug">
.container
  page-header(
    :disable-back="true"
  )
  .wrapper: .content: div
    .page.detail-page
      h2 Wettbewerbs-Entwürfe
    .flexbox
      .card(v-for="i in 6" @click="$router.push('/detail/'+i)")
        img.responsive(:src="require(`@/assets/img/thumbs/${i}-1.jpg`)")
        .card-title(v-if="i <= 3") {{i}}. Preis
        .card-title(v-else) Teilnehmer
        img.logo(:src="require(`@/assets/img/logos/${i}.png`)")
        .card-title(style="margin-top: 15px;") {{names[i-1]}}

</template>

<script>
export default {
  data(){
    return {
      names: [
        "Greenbox Landschaftsarchitekten Schäfer + Pieper PartG mbB, Köln",
        "PLANSTATT SENNER, Überlingen",
        "GMO13 Landschaftsarchitekten, Berlin",
        "Studio Polymorph, Berlin",
        "Pola Landschaftsarchitekten, Berlin",
        "Topotek 1, Berlin"
      ]
    }
  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .logo{
    height: 60px;
    max-width: 100%;
    margin-top: 40px;
  }
  .card{
    width: 16%;
  }
@media (max-width: 1000px) {
  .flexbox{
    display: block;
  }
  .card{
    width: 100%;
  }
  .responsive{
    width: auto;
  }
  .content{
    display: block;
  }
}

</style>
